import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Github from "./Github";
import Techstack from "./Techstack";
import Aboutcard from "./AboutCard";
import Toolstack from "./Toolstack";
import ResearchInterests from "./Research";
import myImg from "../../Assets/avatar.svg";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";
import { FaFacebook } from "react-icons/fa";
import {FaHackerrank} from "react-icons/fa";
import {FaStackOverflow} from "react-icons/fa";
import {FaDev} from "react-icons/fa";


function About() {
  return (
    <Container fluid className="about-section">
      <Container>
        {/* <Row style={{ justifyContent: "center", padding: "10px" }}>
          <Col
            md={7}
            style={{
              justifyContent: "center",
              paddingTop: "30px",
              paddingBottom: "50px",
            }}
          >
            <h1 style={{ fontSize: "2.1em", paddingBottom: "20px" }}>
              <strong className="purple">About Me</strong>
            </h1>
            <Aboutcard />
          </Col>
          <Col className="myAvtar">
           <Tilt>
             <img src={myImg} className="img-fluid" alt="avatar" />
           </Tilt>
           <h4>Social Networks</h4>
           <ul className="home-about-social-links">
             <li className="social-icons">
               <a
                 href="https://github.com/vinuri-s"
                 target="_blank"
                 rel="noreferrer"
                 className="icon-colour  home-social-icons"
               >
                 <AiFillGithub />
               </a>
             </li>
             
             <li className="social-icons">
               <a
                 href="https://www.hackerrank.com/vinzi008"
                 target="_blank"
                 rel="noreferrer"
                 className="icon-colour  home-social-icons"
               >
                 <FaHackerrank />
               </a>
             </li>
             <li className="social-icons">
               <a
                 href="https://stackoverflow.com/users/12144945/vinuri"
                 target="_blank"
                 rel="noreferrer"
                 className="icon-colour  home-social-icons"
               >
                  <FaStackOverflow/>
               </a>
             </li>
             <li className="social-icons">
               <a
                 href="https://dev.to/vinuri_s"
                 target="_blank"
                 rel="noreferrer"
                 className="icon-colour  home-social-icons"
               >
                 <FaDev />
               </a>
             </li>
           </ul>
          </Col>
        </Row> */}
        <h1 className="project-heading">
          <strong className="purple">Technical Exposure </strong>
        </h1><br />

        <Techstack />

        <h1 className="project-heading">
          <strong className="purple">Familiar Operating Systems & Tools</strong>
        </h1>
        <Toolstack />
        <h1 className="project-heading">
          <strong className="purple">Research Interests</strong>
        </h1>
        <ResearchInterests />

        {/* <Github /> */}
      </Container>
    </Container>
  );
}

export default About;
